module.exports = __webpack_public_path__ + "static/media/lauren-cohen-win.44026c49.jpg";